// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"ef941019","253":"f6010545","266":"9669385c","369":"55d72f69","489":"2937681b","634":"a44be8b0","656":"67a2e9cd","819":"695781f3","933":"291db25e"}[chunkId] + ".chunk.js";
};